module.exports = __webpack_public_path__ + "img/kakao_symbol.0daecc42.svg";